module.exports = __webpack_public_path__ + "media/bannermp4.a520702f.mp4";